export const iconFontAwesomeLogisticsGasPump = (
	<i className="fa-solid fa-gas-pump"></i>
);
